import { ISigningAppointmentDocumentResponse } from 'types/signingAppointment/ISigningAppointmentDocumentResponse';
import { ISigningAppointmentResponse } from 'types/signingAppointment/ISigningAppointmentResponse';

// checks if a document has been sent to sig sync
export const isSent = (document?: ISigningAppointmentDocumentResponse) => !!(document?.sentAt ?? document?.sentBy);

// checks if an array of documents associated to an appointment contains sent documents
export const hasSentDocuments = (documents?: ISigningAppointmentDocumentResponse[]) =>
  (documents ?? []).some((document) => isSent(document));

// checks if an array of documents associated to an appointment contains unsent documents
export const hasUnsentDocuments = (documents?: ISigningAppointmentDocumentResponse[]) =>
  (documents ?? []).some((document) => !isSent(document));

// checks if an array of documents associated to an appointment contains documents marked for deletion
export const hasMarkedForDeletionDocuments = (documents?: ISigningAppointmentDocumentResponse[]) =>
  (documents ?? []).some((document) => !!document?.markedForDeletionAt);

// Checks if digital scheduling sig sync appointment is confirmed to show the documents tab
export const shouldHideTabForDigitalSchedulingSigSyncAppointment = (appointment: ISigningAppointmentResponse) => {
  const { isDigitalScheduling, isSignatureSyncAppointment, isDigitalSchedulingConfirmed } = appointment;

  return isDigitalScheduling && isSignatureSyncAppointment && !isDigitalSchedulingConfirmed;
};
